import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import dayjs from 'dayjs';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SiteMenu } from '../../config/site-menu';
import { AppState } from '../app.state';
import { SharedService } from '../core/services/shared.service';
import { StorageService } from '../core/services/storage/storage.service';
import { IMenuItem } from '../shared/components/menu/menu-item.interface';
import { SideBarMenuComponent } from '../shared/components/side-bar-menu/side-bar-menu.component';
import { ISiteAnnouncement } from '../shared/components/site-announcement/models/site-announcement.interface';
import { Customer } from '../shared/models/customer/customer.model';
import { AnnouncementService } from '../shared/services/announcement/annoucement.service';
import { BetaFeatureService } from '../shared/services/beta-feature.service';
import { User } from '../shared/services/user/models/user.model';
import { UserService } from '../shared/services/user/user.service';
import { UtilityService } from '../shared/services/utility/utility.service';

@Component({
    selector: 'upsc-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
    // public userStream: Observable<User>;
    // public customerStream: Observable<Customer>;
    @ViewChild('sidenav') sidenav: MatSidenav;
    @ViewChild('wrapper') wrapper: ElementRef;
    @ViewChild('sideBarMenu', { static: true }) public sideBarMenu: SideBarMenuComponent;

    public menuItems: IMenuItem[];
    public isSidenavOpened = false;
    public showSidebar = true;
    public toggleIt = true;
    public siteAnnouncements: ISiteAnnouncement[];
    public siteAnnouncement: ISiteAnnouncement;
    public shouldDisplaySiteAnnouncement = false;
    public isSiteAnnouncementClosed = false;

    private customer: Customer;
    private getSiteAnnouncementsSubscription: Subscription;
    private isSiteAnnouncementsLoading = false;

    constructor(private userService: UserService,
                private announcementService: AnnouncementService,
                private utilityService: UtilityService,
                private storageService: StorageService,
                private storage: StorageMap,
                private sharedService: SharedService,
                private route: ActivatedRoute,
                private readonly betaFeatureService: BetaFeatureService,
                private readonly appState: AppState,
    ) {
        this.customer = this.appState.customer$();
        this.loadSiteAnnouncements(this.customer?.ShippingStationId);

        this.showSidebar = typeof this.route.snapshot.data['showSidebar'] === 'undefined' ? true : this.route.snapshot.data['showSidebar'];

        this.loadInitialValues();
        // this.betaFeatureService.checkOnRefresh();
    }

    public ngOnInit() {
        this.menuItems = SiteMenu;
    }

    onMenuToggle(val: string) {
        const wrapper = document.getElementById('wrapper');
        // if (!wrapper.classList.contains('toggled')) {
        //   this.toggleIt=true;
        // }
        // else this.toggleIt=false;

        //wrapper.classList.toggle('toggled');

        // 'toggled' means 'opened'!
        this.isSidenavOpened = this.toggleIt;//wrapper.classList.contains('toggled');
        // if (!wrapper.classList.contains('toggled')) {
        //   wrapper.classList.add('toggled')
        // } else {
        //   wrapper.classList.remove('toggled');
        // }
    }

    public onSidenavToggled(isToggled: boolean) {
        const wrapper = document.getElementById('wrapper');
        wrapper.classList.toggle('toggled');
        this.isSidenavOpened = wrapper.classList.contains('toggled');
        this.sideBarMenu.toggleMenu();
        // this.isSidenavOpened = !this.isSidenavOpened;
        //
        // if (this.sidenav.opened) {
        //   this.sidenav.close();
        //   return;
        // }
        //
        // this.sidenav.open();
    }

    public getCurrentYear() {
        return (new Date()).getFullYear();
    }

    public onSiteAnnouncementClosed(isClosed: boolean) {
        this.isSiteAnnouncementClosed = isClosed;

        // This line prevents the site announcement to reappear after a user closes it.
        // Comment this line out if the site announcement should reappear for every page.
        this.sharedService.isSiteAnnouncementClosed = isClosed;
    }

    private loadInitialValues() {
        // const user = this.sharedService.userSubject.getValue();
        // const customer = this.sharedService.customerSubject.getValue();
        // this.userStream = user ? this.sharedService.userSubject.asObservable() : this.userService.getUser();
        // this.customerStream = customer ? this.sharedService.customerSubject.asObservable() : this.userService.getCustomer(user.CustomerId);
        this.isSiteAnnouncementClosed = this.sharedService.isSiteAnnouncementClosed;
    }

    private loadSiteAnnouncements(shippingStationId: string) {
        if (this.isSiteAnnouncementsLoading) {
            return;
        }

        // const cachedSiteAnnouncements = this.storageService.getWithExpiration('site-announcements');

        this.storage.get('site-announcements').subscribe(
            (res: any) => {
                if (!res) {
                    this.getSiteAnnouncements(shippingStationId);
                    return;
                }

                if (dayjs().isAfter(dayjs(res.expiration))) {
                    this.getSiteAnnouncements(shippingStationId);
                    return;
                }

                const cachedSiteAnnouncements = res.announcements;
                this.siteAnnouncements = <ISiteAnnouncement[]>cachedSiteAnnouncements;
                this.shouldDisplaySiteAnnouncement =
                    !!this.siteAnnouncements
                    && !!this.siteAnnouncements.length
                    && !this.sharedService.isSiteAnnouncementClosed;
                this.siteAnnouncement = this.shouldDisplaySiteAnnouncement ? this.siteAnnouncements[0] : null;
            },
        );
    }

    private getSiteAnnouncements(shippingStationId: string): void {
        this.isSiteAnnouncementsLoading = true;

        this.utilityService.clearSubscriptions([this.getSiteAnnouncementsSubscription]);
        this.getSiteAnnouncementsSubscription =
            this.announcementService.getSiteAnnouncements(shippingStationId)
                .pipe(
                    catchError((err) => {
                        this.siteAnnouncements = null;
                        this.shouldDisplaySiteAnnouncement = false;
                        this.siteAnnouncement = null;
                        this.isSiteAnnouncementsLoading = false;

                        return of(null);
                    }),
                )
                .subscribe(
                    (announcements) => {
                        this.siteAnnouncements = announcements;
                        this.shouldDisplaySiteAnnouncement =
                            !!this.siteAnnouncements
                            && !!this.siteAnnouncements.length
                            && !this.sharedService.isSiteAnnouncementClosed;
                        this.isSiteAnnouncementsLoading = false;

                        if (!announcements?.length) {
                            this.siteAnnouncement = null;
                            return;
                        }

                        this.siteAnnouncement = this.shouldDisplaySiteAnnouncement ? this.siteAnnouncements[0] : null;

                        // cache it for 5 min.
                        const data = {
                            data: announcements,
                            expiration: 300000,
                        };

                        this.storage.set('site-announcements', data).subscribe(() => {});
                    },
                );
    }
}
